import "css/index.css";

import React from "react";
import ReactDOM from "react-dom/client";

import { QueryProvider } from "api";

/* eslint-disable global-require */
const getApp = () => {
  if (process.env.REACT_APP_TYPE === "admin") return require("./apps/admin/App.js").default;
  return require("./apps/collectors/App").default;
};

const App = getApp();
/* eslint-enable global-require */

const root = ReactDOM.createRoot(document.getElementById("root"));

const isAdmin = process.env.REACT_APP_TYPE === "admin";

document.title = isAdmin ? "ODITI Admin Dashboard" : "ODITI Collectors Archive";

const content = (
  <QueryProvider>
    <App />
  </QueryProvider>
);

if (!process.env.REACT_APP_STRICT_MODE || process.env.REACT_APP_STRICT_MODE === "false")
  root.render(content);
else root.render(<React.StrictMode>{content}</React.StrictMode>);
